import api from "!../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/cjs.js!./common.less";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};


//////////////////
// WEBPACK FOOTER
// ./node_modules/style-loader/dist/cjs.js!./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/assets/style/common.less
// module id = null
// module chunks = 